import { PdfGen, PdfUnit, PdfSize, PdfPoint, PdfRect, PdfBrush, ETextAlign } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/helpers';

export class CardsAside implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const ITEMS_PER_PAGE = 10;
    const cols = 2;
    const rows = 5;

    const count = Math.min(opts.list.length, this.countMax());
    const pageCount = Math.ceil(count / ITEMS_PER_PAGE);

    for (let i = 0; i < pageCount; i++) {
      pdf.addPage();
    }

    const cardWidth = PdfSize.A4.width / cols / 2;
    const cardHeight = PdfSize.A4.height / rows;
    const margin = PdfUnit.FromMillimeters(5);
    const cellSize = new PdfSize(cardWidth - 2 * margin, cardHeight - 2 * margin);

    const leftTexts: string[][] = [];
    const rightTexts: string[][] = [];

    for (let i = 0; i < count; i++) {
      const item = opts.list[i];
      const leftText = item.left.getText() ?? '';
      const rightText = item.right.getText() ?? '';
      leftTexts.push(leftText ? [leftText] : []);
      rightTexts.push(rightText ? [rightText] : []);
    }

    for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
      const page = pdf.getPage(pageIndex);

      const pageLeftTexts = leftTexts.slice(
        pageIndex * ITEMS_PER_PAGE,
        (pageIndex + 1) * ITEMS_PER_PAGE
      );
      const pageRightTexts = rightTexts.slice(
        pageIndex * ITEMS_PER_PAGE,
        (pageIndex + 1) * ITEMS_PER_PAGE
      );

      const allTexts = [...pageLeftTexts, ...pageRightTexts];
      const font = page.adjustFontMulti(allTexts, GUtil.baseFont, cellSize);

      for (let x = 1; x < cols * 2; x++) {
        page.drawLine(
          GUtil.cutPen,
          new PdfPoint(x * cardWidth, 0),
          new PdfPoint(x * cardWidth, PdfSize.A4.height)
        );
      }
      for (let y = 1; y < rows; y++) {
        page.drawLine(
          GUtil.cutPen,
          new PdfPoint(0, y * cardHeight),
          new PdfPoint(PdfSize.A4.width, y * cardHeight)
        );
      }

      for (let x = 0; x < cols; x++) {
        for (let y = 0; y < rows; y++) {
          const index = y * cols + x;
          if (index >= pageLeftTexts.length) continue;

          const r1 = new PdfRect(
            x * 2 * cardWidth + margin,
            y * cardHeight + margin,
            cardWidth - 2 * margin,
            cardHeight - 2 * margin
          );
          const r2 = new PdfRect(
            (x * 2 + 1) * cardWidth + margin,
            y * cardHeight + margin,
            cardWidth - 2 * margin,
            cardHeight - 2 * margin
          );

          page.drawLabel(opts.list[pageIndex * ITEMS_PER_PAGE + index].left, {
            rect: r1,
            font,
          });
          page.drawLabel(opts.list[pageIndex * ITEMS_PER_PAGE + index].right, {
            rect: r2,
            font,
          });
        }
      }
    }
  }
}
